/**
 * Admin 格式化工具
 */

import dayjs from 'dayjs'

/** 格式化日期 */
export function formatDate(date: string | Date | null | undefined, format: string = 'YYYY-MM-DD HH:mm'): string {
  if (!date) return '-'
  const d = dayjs(date)
  if (!d.isValid()) return '-'
  return d.format(format)
}

/** 格式化日期（仅日期） */
export function formatDateOnly(date: string | Date | null | undefined): string {
  if (!date) return '-'
  const d = dayjs(date)
  if (!d.isValid()) return '-'
  return d.format('YYYY-MM-DD')
}

/** 数字千分位 */
export function formatNumber(n: number): string {
  if (n === null || n === undefined || isNaN(n)) return '0'
  return n.toLocaleString('en-US')
}

/** 货币格式 */
export function formatCurrency(n: number): string {
  if (n === null || n === undefined || isNaN(n)) return '¥0'
  return `¥${n.toLocaleString('en-US')}`
}
